import { render, staticRenderFns } from "./dr-expansion-panel.vue?vue&type=template&id=3e151583"
import script from "./dr-expansion-panel.vue?vue&type=script&lang=js"
export * from "./dr-expansion-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports